/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IUserLocation } from './IUserLocation';
import {
    IUserLocationFromJSON,
    IUserLocationFromJSONTyped,
    IUserLocationToJSON,
    IUserLocationToJSONTyped,
} from './IUserLocation';

/**
 * 
 * @export
 * @interface GroupLocations
 */
export interface GroupLocations {
    /**
     * 
     * @type {string}
     * @memberof GroupLocations
     */
    group_id: string;
    /**
     * 
     * @type {Array<IUserLocation>}
     * @memberof GroupLocations
     */
    user_locations: Array<IUserLocation>;
}

/**
 * Check if a given object implements the GroupLocations interface.
 */
export function instanceOfGroupLocations(value: object): value is GroupLocations {
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('user_locations' in value) || value['user_locations'] === undefined) return false;
    return true;
}

export function GroupLocationsFromJSON(json: any): GroupLocations {
    return GroupLocationsFromJSONTyped(json, false);
}

export function GroupLocationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupLocations {
    if (json == null) {
        return json;
    }
    return {
        
        'group_id': json['group_id'],
        'user_locations': ((json['user_locations'] as Array<any>).map(IUserLocationFromJSON)),
    };
}

export function GroupLocationsToJSON(json: any): GroupLocations {
    return GroupLocationsToJSONTyped(json, false);
}

export function GroupLocationsToJSONTyped(value?: GroupLocations | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['group_id'],
        'user_locations': ((value['user_locations'] as Array<any>).map(IUserLocationToJSON)),
    };
}

